var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoundSpeakers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.083313,
    width: 14,
    height: 14,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10561_18079",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_10561_18079",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAD/klEQVR4nO3dT2gcVRzA8e9v2m2KpmiQHFSKghQ8SI9SxLaklQq59FK27k6s5KCQrG3Eg+c960Eb2Q2oEGozuzEoBsV48FAUQUEvFQ/Sk6L0EqGK0DYxOz8Ppb20Jtl03ry+l9/nmp03v8wXdmf2LxhjjDHGGGOMMcYYY8x2IL4H8KG1sDAoq72XNNGjqDyM6B+ofj5cqWTVarVX5izbLkC70zmsyjngsTv8+cc8keOna7XLZc2zrQK057r1XHRWYNc6N/tppbLzwOvV6rUyZkrK2Mm9oJVlUyp6foODD7B/17+9l0sZCthZ1o58aTabyfC+fW+DnNnsNkI+Bkw7HOuWqAPMzs7uvjowcB7lRH9bypNuJrpdtAHaWTZ0FVlEObSFzfcUPtD/iDLAu93uI5rrl8B+37NsJLoH4ZkP559Kcv2eAA4+RBaglWUj+Y78W2Cv71k2K5oArbnuCZAl4AHfs/QjigCtLJtC9CNgt+9Z+hV0AFWV9lznTZB3CPR/CfYsaHppaaDd6ZxD5KTvWe5GkAHaWTakV/5aBNnKOf49JbgAIZ3jb0ZQ95uhneNvRjABQjzH34xS7oJaWTaCSA3lIDcO4P1l7DcETgNMz88/kfTy94AjqMs9hctZgFa3+wy9/DPgIVf7iIGTx4CZbvdxcl3EDv6GnATI8/wDYNjF2rEpPMBMp3ME5GjR68aq8ACq1IpeM2bFB4CDRa8ZMxePAY86WDNaLgIMOlgzWsE8FRErC+CZBfDMAnhmATyzAJ5ZAM8sgGcWwDML4JkF8MwCeGYBPHMR4B8Ha0bLRYDSPuQcAweviMnXRa8Zs8IDCPl80WvGrPAAjTS9AHxV9LqxcnIWlCTyCrDsYu3YOAkwUav9qsJx4E8X68fE2XXAq/X6d3lv7Wns7mhdpXxdTbvTOaw5NeAQwl4CeOdEI62XcmyC+b6gVpaNgHxKSZ8DLitAME9FNNL0QtJLngV+9z1LkYIJADBx6oWf80QOiHDR9yxFCSoAwOla7TKqI8A3vmcpQnABACbT9Epv6MFjAsFfdQcZAODM6OjKRL1WF+Ut37PcjWADAIiITo7V3wB9Dch9z7MVQQe4qZGmZ3OhClz3PUu/oggAcLpe/wR0FPjb9yz9iCYAhHmtEFUACO9aIboAENa1QpQB4Ma1wn2rK88jfLyFzUt7Y0G0AQDGx8evL1+6dBK0z68h1l/cTHS7qAMANJvNvJGmU/1cKyjJnOOxbok+wE2NND0rKi8qrK53OxEurlZ2vF/WXNsmAMDkWK2TCMeA3+58C/2hJzJa1m8HQEAvyBSptbAwyNraKeA5lD0oy4h+MVypzJf9EybGGGOMMcYYY4wxxhizPfwHEScL4NlI6/cAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundSpeakers);
export default __webpack_public_path__ + "static/media/sound_speakers.d768668abb218611acfade800c182186.svg";
export { ForwardRef as ReactComponent };